import React from 'react'
import { useAppSelector, useAppDispatch } from '../store/store'
import { chooseMethod } from '../store'
import {
  AuthMethodOptions,
  AuthMethodEnum,
  AvatarType,
  onMethodChange,
} from '../types.d'
import { InjectedFrameProps, withFrameProps } from './withFrameProps'

export type InjectedAuthProps = {
  avatar: AvatarType
  displayName: string
  email: string
  onMethodChange: onMethodChange
} & InjectedFrameProps

export function withAuthProps<P>(WrappedComponent: React.ComponentType<P>) {
  const WithFrame = withFrameProps(WrappedComponent, { hasPreviousStep: true })

  return function WithAuthProps(props: Omit<P, keyof InjectedAuthProps>) {
    const dispatch = useAppDispatch()
    const signinData = useAppSelector((state) => state.auth.signin)

    if (!signinData?.userInfo) {
      return null // This shouldn't happen but provides type safety
    }

    const { avatar, displayName, email } = signinData.userInfo

    const extraAuthProps = {
      avatar,
      displayName,
      email,
      onMethodChange: (chosenMethod) => (_e) =>
        dispatch(chooseMethod(chosenMethod)),
    }

    return <WithFrame {...(props as P)} {...extraAuthProps} />
  }
}
